import { render } from "./DismantlingScanView.vue?vue&type=template&id=8b1903b2&scoped=true&ts=true&lang=pug"
import script from "./DismantlingScanView.vue?vue&type=script&lang=ts"
export * from "./DismantlingScanView.vue?vue&type=script&lang=ts"

import "./DismantlingScanView.vue?vue&type=style&index=0&id=8b1903b2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1903b2"]])

export default __exports__